import { gameAudio } from '../../audio/GameAudio';
import { primeAudioOnFirstGesture } from '../../boot/BootHelpers';
import type { System } from '../ServiceLocator';

export class AudioSystem implements System {
  readonly name = 'AudioSystem';

  readonly gameAudio = gameAudio;

  init(): void {
    primeAudioOnFirstGesture();
  }
}
